export const FEEDBACK_KIND_LABELS: Record<string, string> = {
  BUG: 'Something is broken',
  DEVICE_REQUEST: 'Missing equipment',
  FEATURE: 'Feature idea',
  OTHER: 'Something else',
}
export type OwnFeedbackDTO = { id: string; kind: string; message: string; createdAt: string; resolvedAt: string | null; reply: string | null }
export type FeedbackDTO = OwnFeedbackDTO & {
  submittedByEmail: string
  workspaceSlug: string | null
  pagePath: string | null
  userAgent: string | null
  appVersion: string | null
  resolvedBy: string | null
}
